
import { defineComponent } from 'vue';
import { useI18n } from '@/i18n-shim'
import useEsignCommon, { shortDisplayName } from '@/eSign-i18n'

export default defineComponent({
  name: 'LanguageSelector',
  setup() {

    const i18n = useI18n();
    const eSignCommon = useEsignCommon();

    return {
      availableLanguages: eSignCommon.availableLanguages,
      setLanguage: eSignCommon.setLanguage,
      languageDisplayName: shortDisplayName,
      ...i18n
    };
  },
});
